import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TeamsService} from '../../services/teams/teams.service';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {SessionService} from '../../services/session/session.service';

interface PurchasesLink {
  title: string;
  link: string;
}

const ALL_LINKS: PurchasesLink[] = [
  { title: 'Transactions', link: '/purchases/transactions'},
  { title: 'Receipts to Approve', link: '/purchases/awaitingapproval'},
  { title: 'Approved Receipts', link: '/purchases/approved'},
  { title: 'Denied Receipts', link: '/purchases/denied'},
  { title: 'Reimbursements', link: '/purchases/reimbursed'},
  { title: 'Configure Approvers', link: '/purchases/configure'},
];

@Component({
  selector: 'app-purchases',
  templateUrl: './purchases.component.html',
  styleUrls: ['./purchases.component.scss']
})
export class PurchasesComponent implements OnInit, AfterViewInit {

  public links: PurchasesLink[] = [...ALL_LINKS];
  public activeLink?: PurchasesLink;

  constructor(
      private router: Router,
      private teamsService: TeamsService,
      private spinnerService: SpinnerService,
      private sessionService: SessionService,
  ) { }

  ngOnInit(): void {
    if (this.sessionService.isTeamAgentSession()) {
      this.links = this.links.filter(link => link.title === 'Transactions');
    }
    const parsedUrl = this.router.parseUrl(this.router.url);
    const urlSegments = parsedUrl.root.children.primary.segments;
    urlSegments.length = 2;
    this.activeLink = this.links.find(link => link.link === parsedUrl.toString());
    if (!this.activeLink) {
      this.activeLink = this.links[0];
      this.router.navigate([this.activeLink.link]);
    }

  }

  ngAfterViewInit(): void {
  }

  gotoTab(link: PurchasesLink): void {
    this.activeLink = link;
    this.router.navigate([link.link]);
  }

}
